import { useT } from '../i18n/LanguageContext'
import { useDocumentMeta } from '../hooks/useDocumentMeta'
import Hero from '../components/Hero'
import About from '../components/About'
import Product from '../components/Product'
import ProductPluginCommerce from '../components/ProductPluginCommerce'
import Oferta from '../components/Oferta'
import Realizacje from '../components/Realizacje'
import CTA from '../components/CTA'

/**
 * Strona główna — dokładnie ten sam układ sekcji co przed wydzieleniem bloga.
 * Navbar i Footer żyją piętro wyżej (App), bo są wspólne dla wszystkich tras.
 */
export default function Landing() {
  const t = useT()
  useDocumentMeta(t.meta.title, t.meta.description)

  return (
    <>
      <Hero />
      <About />
      <Product />
      <ProductPluginCommerce />
      <Oferta />
      <Realizacje />
      <CTA />
    </>
  )
}
